import qs from "qs";
import uuid from "uuid";
import { DEV_MODE, setNewLocation, getLocationHash, localStorageSet, localStorageGet, isMobileOrTablet, getWindowHref } from "./window";
import { getParameterByName } from './query-params';

// https://developer.spotify.com/documentation/general/guides/scopes/
const playlist_read_scopes = 'playlist-read-private playlist-read-collaborative';
const user_songs_scopes = 'user-library-read user-read-recently-played user-top-read';
const user_profile = 'user-read-private';

const client_id = '0ac97eccd28b4c6bbb0bb93c875ff240';
const redirect_uri = DEV_MODE ?
  'http://localhost:8000/spotifyauthcallback'
  :
  'https://playlistbuddyapp.com/spotifyauthcallback';

const scope = `${user_profile} ${playlist_read_scopes} ${user_songs_scopes}`;
const response_type = 'token';
const state = uuid(); // Could make this a UUID

// https://developer.spotify.com/documentation/general/guides/authorization-guide/
const authSpotify = ( show_dialog ) => {
  // Always show dialog for mobile since my iPhone wasn't working unless that is set to true
  const queryString = qs.stringify({ client_id,  redirect_uri, scope, response_type, state, show_dialog: isMobileOrTablet() || show_dialog });
  setNewLocation(`https://accounts.spotify.com/authorize?${queryString}`);
};

const handleSpotifyAuthCallback = () => {
  console.log(getWindowHref())
  const accessDenied = getParameterByName('error');
  if (accessDenied) {
    return false;
  }

  const access_token = getParameterByName('access_token', `?${getLocationHash()}`);
  const expires_in = getParameterByName('expires_in');

  localStorageSet('PB_SPOTIFY_ACCESS_TOKEN', access_token);
  localStorageSet('PB_SPOTIFY_ACCESS_TOKEN_EXPIRES_AT', parseInt(Date.now()) + (parseInt(expires_in) * 1000));

  return true;
};

const isSpotifyAccessTokenValid = () => {
  if (localStorageGet('PB_SPOTIFY_ACCESS_TOKEN')) {
    const expiresAt = localStorageGet('PB_SPOTIFY_ACCESS_TOKEN_EXPIRES_AT');

    return parseInt(expiresAt) > Date.now();
  }

  return false;
}

const getSpotifyAccessToken = () => {
  return localStorageGet('PB_SPOTIFY_ACCESS_TOKEN');
}

const logoutOfSpotify = (callback) => {
  localStorageSet('PB_SPOTIFY_ACCESS_TOKEN', '');
  localStorageSet('PB_SPOTIFY_ACCESS_TOKEN_EXPIRES_AT', '');
  localStorageSet('PB_SPOTIFY_PROFILE', '');


  const url = 'https://www.spotify.com/logout/';
  const spotifyLogoutWindow = window.open(url, 'Spotify Logout', 'width=700,height=500,top=40,left=40');
  setTimeout(() => {
    spotifyLogoutWindow.close();
    callback && callback();
  }, 2000);
}

const logoutOfSpotifyAndRedirectToHome = () => {
  const redirectToHomeCallback = () => (setNewLocation('/'));
  logoutOfSpotify(redirectToHomeCallback);
}

export {
  authSpotify,
  handleSpotifyAuthCallback,
  isSpotifyAccessTokenValid,
  getSpotifyAccessToken,
  logoutOfSpotify,
  logoutOfSpotifyAndRedirectToHome
}

// Get my playlists
// GET https://api.spotify.com/v1/me/playlists
// Limit Minimum: 1. Maximum: 50., offset: X

// id	string	The Spotify ID for the playlist.
// name	string	The name of the playlist.
// SHOW a public private badge?
//public	Boolean or null	The playlist’s public/private status: true the playlist is public, false the playlist is private, null the playlist status is not relevant.

// tracks	a tracks object	A collection containing a link ( href ) to the Web API endpoint where full details of the playlist’s tracks can be retrieved, along with the total number of tracks in the playlist.



// WEBPACK FOOTER //
// ./src/lib/spotify-auth.js